import serviceRequest from "utils/request";

const baseUrl = "/api/hardware";

export const getHardwareRequests = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-hardware-requests`,
		method: "get",
		params,
	});
};

export const getHardwareRequestsRes = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-hardware-requests-res`,
		method: "get",
		params,
	});
};

export const getHardwareDetail = (params) => {
	return serviceRequest({
		url: `${baseUrl}/detail`,
		method: "get",
		params,
	});
};

export const hardwareSubmit = (param) => {
	return serviceRequest({
		url: `${baseUrl}/submit`,
		method: "post",
		data: param,
	});
};

export const hardwareEdit = (param) => {
	return serviceRequest({
		url: `${baseUrl}/edit`,
		method: "post",
		data: param,
	});
};

